import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import { PilotDemoBanner } from './PilotDemo';
import AssistanceLauncher from './help/AssistanceLauncher';

interface Props {
  children: React.ReactNode;
  /** Optional handler so guided-tour steps can navigate dashboard tabs. */
  onGuidanceJump?: (tab: string) => void;
}

const PortalShell: React.FC<Props> = ({ children, onGuidanceJump }) => {
  return (
    <div className="min-h-screen flex flex-col bg-eds-bg">
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
      <PilotDemoBanner />
      {/* In-app guidance: role-aware first-time welcome, replayable tour, help center */}
      <AssistanceLauncher onJump={onGuidanceJump} />
    </div>
  );
};

export default PortalShell;
